import { newSpecPage } from '@stencil/core/testing'
import { CobaltNotificationPill } from '../cobalt-notification-pill'

describe('cobalt-notification-pill', () => {
  it('should render an empty notification pill element', async () => {
    const page = await newSpecPage({
      components: [CobaltNotificationPill],
      html: '<cobalt-notification-pill></cobalt-notification-pill>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-notification-pill class="cobalt-notification-pill" role="status">
        <core-notification-pill></core-notification-pill>
      </cobalt-notification-pill>
    `)
  })
})
